import React from 'react';
import { RenderTableConfig } from 'AppConfig/TableConfig/Render';

// "Render.ResultsProcessStatementTable.EvalYear"
const parseExpression = (input) => {
  const PREFIX = 'Render.';

  if (!input.startsWith(PREFIX)) {
    return undefined;
  }

  const path = input.slice(PREFIX.length).split('.');
  if(!(path || []).length) {
    return undefined;
  }

  return path.reduce((obj, key) => (obj && obj[key] !== 'undefined') ? obj[key] : null, RenderTableConfig);
}

export const getCustomRenderer = ({ key, value, record }) => {
  const RenderComponent = parseExpression(key);
  if(!RenderComponent) {
    return undefined;
  }

  return <RenderComponent value={value} record={record} />
}
